
import Odontograma from "./Odontograma";

export default function OdontogramaPanel({ value, onChange }) {
  return (
    <section
      style={{
        color: "#1e293b",
        background: "#f7faff",
        border: "1px solid #e1eaf5",
        borderRadius: 20,
        padding: "clamp(14px, 2.2vw, 28px)",
        boxShadow: "0 6px 22px rgba(40, 75, 120, 0.045)",
        display: "flex",
        flexDirection: "column",
        gap: 22,
        minWidth: 0,
        fontFamily:
          'Inter, ui-sans-serif, system-ui, -apple-system, sans-serif',
      }}
    >
      <header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 14,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 13,
          }}
        >
          <div
            style={{
              width: 46,
              height: 46,
              flexShrink: 0,
              borderRadius: 14,
              display: "grid",
              placeItems: "center",
              background:
                "linear-gradient(145deg, #eaf5ff, #f0f5ff)",
              border: "1px solid #dceafb",
              color: "#4385c5",
              fontSize: 24,
            }}
          >
            ◉
          </div>

          <div>
            <h2
              style={{
                margin: 0,
                fontSize: "clamp(19px, 2vw, 25px)",
                fontWeight: 750,
                letterSpacing: "-.7px",
                color: "#1e293b",
              }}
            >
              Odontograma clínico
            </h2>

            <p
              style={{
                margin: "5px 0 0",
                color: "#718198",
                fontSize: 12,
              }}
            >
              Registro visual del estado dental
            </p>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            border: "1px solid #e0eaf5",
            borderRadius: 12,
            padding: "9px 12px",
            background: "#f1f7fd",
            color: "#52677f",
            fontSize: 12,
          }}
        >
          <span
            style={{
              width: 7,
              height: 7,
              borderRadius: "50%",
              background: "#34b889",
            }}
          />
          Registro clínico
        </div>
      </header>

      <div
        style={{
          borderRadius: 16,
          border: "1px solid #e2eaf4",
          background:
            "linear-gradient(145deg, #f9fcff 0%, #f4f8fd 100%)",
          padding: "clamp(10px, 1.5vw, 22px)",
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        <Odontograma value={value} onChange={onChange} />
      </div>
    </section>
  );
}
